// Must be first to load polyfills
import './bootstrap';
import './firebaseSetup';

import * as ReactDOM from 'react-dom';

import App from './App';
import AuthPersistGate from './modules/components/AuthPersistGate';
import {AuthContextType} from './contexts/AuthContext';

ReactDOM.render(
  <AuthPersistGate>
    {(auth: AuthContextType) => <App auth={auth} />}
  </AuthPersistGate>,
  document.getElementById('root')
);
